export default __webpack_public_path__ + "static/media/visualizer.8020915e.gif";